
namespace Gamification.Gamification {
    export class ProdottiAssetEsperienzeColumns {
        static columnsKey = 'Gamification.ProdottiAssetEsperienze';
    }
}